import { AsyncSelect } from 'chakra-react-select';
import {
  useState,
} from 'react';
import {
  autoComplete,
  placeDetails,
  PlacePrediction,
} from '../../services/googlePlaces';

const MIN_CHARS = 3;

type SelectedPlace = Awaited<ReturnType<typeof placeDetails>>;
const PlaceSearch = ({ onSelect }: { onSelect: (value: SelectedPlace) => void }) => {
  const [predictions, setPredictions] = useState<Array<PlacePrediction>>([]);

  const onPredictionSelect = async (placePrediction: PlacePrediction) => {
    const details = await placeDetails({ placeId: placePrediction.placeId });
    onSelect(details);
  };

  return (
    <AsyncSelect
      // @ts-ignore
      loadOptions={async (query: string) => {
        if (query?.length < MIN_CHARS) return null;

        const results = await autoComplete({ query });
        // Store loaded options to work around ridiculous behaviour in react-select
        setPredictions(results);
        return results;
      }}
      defaultOptions={predictions}
      cacheOptions
      getOptionLabel={(place) => place.text.text}
      getOptionValue={(place) => place.placeId}
      // @ts-ignore
      onChange={onPredictionSelect}
      placeholder="Enter a location"
      noOptionsMessage={({ inputValue }) => {
        if (!inputValue) return 'Start typing...';
        return 'No results found';
      }}
    />
  );
};

export default PlaceSearch;
